import { render, staticRenderFns } from "./EditBuildingSales.vue?vue&type=template&id=2d285a0f"
import script from "./EditBuildingSales.vue?vue&type=script&lang=js"
export * from "./EditBuildingSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports